import React from 'react'
import PropTypes from 'prop-types'
import trumpet from '../images/trumpet-48.png'
import Banner from './Banner'

const Header = (props) => (
    <header id="header" style={props.timeout ? {display: 'none'} : {}}>
        <div className="logo">
            <span><img src={trumpet} /></span>
        </div>
        <div className="content">
            <div className="inner">
                <h1>Josh Deutsch</h1>
                <p>Musician | Composer | Educator</p>
            </div>
        </div>
        <nav>
            <ul>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('intro')}}>Bio</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('music')}}>Projects</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('shows')}}>Shows</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('lessons')}}>Lessons</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('shop')}}>Discography</a></li>
                <li><a href="javascript:;" onClick={() => {props.onOpenArticle('contact')}}>Contact</a></li>
            </ul>
        </nav>
    </header>
)

Header.propTypes = {
    onOpenArticle: PropTypes.func,
    timeout: PropTypes.bool
}

export default Header
